import { render, staticRenderFns } from "./ui-stat.vue?vue&type=template&id=65a810ba&scoped=true&"
import script from "./ui-stat.vue?vue&type=script&lang=js&"
export * from "./ui-stat.vue?vue&type=script&lang=js&"
import style0 from "./ui-stat.vue?vue&type=style&index=0&id=65a810ba&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a810ba",
  null
  
)

export default component.exports